export default {
  id: 101,
  title: 'Target #101 - Sharingan',
  url: 'https://cssbattle.dev/play/101',
  colors: ['#161616', '#A22015', '#000000', '#E96A23'],
  solution:
    '<a a><a b><style>body{background:#a22015}a{position:fixed}[a]{top:185;left:150;width:100;height:100;border-radius:9in;box-shadow:inset 0 0 0 15px,74px -128px 0 -15px #a22015,74px -128px,-74px -128px 0 -15px #a22015,-74px -128px,0 -85px 0 -25px,0 -85px 0 -15px #e96a23,0 -85px}[b]{top:0;left:0;width:400;height:300;background:radial-gradient(circle,transparent 95px,#000 95px 100px,#161616 100px)}</style>',
}
